import { render, staticRenderFns } from "./CardSerieEdit.vue?vue&type=template&id=4c0ca3b9&"
import script from "./CardSerieEdit.vue?vue&type=script&lang=js&"
export * from "./CardSerieEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports